export default "__VITE_ASSET__BE91S_iy__"